export class SdkApi {
    sharedActionTracking;
    visitor;
    constructor({ sharedActionTracking }) {
        this.sharedActionTracking = sharedActionTracking;
    }
    setVisitor(visitor) {
        this.visitor = visitor;
    }
    getApiV1() {
        return {
            _getActionTrackingNonce: () => this.sharedActionTracking?.generateNonce(),
            _getVisitorId: () => this.visitor?.isClientSuppliedID !== true ? this.visitor?.visitorId : undefined
        };
    }
}
